import { useContext } from 'react';
import {
  useForm,
  useWatch,
  MultiStepFormContext,
} from '@kanda-libs/ks-component-ts';
import { scrollToTop } from 'utils';

export default function useAcceptTermsForm() {
  const { data, handleContinue } = useContext(MultiStepFormContext);

  const { isLoading } = data || {};

  const form = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { acceptedTerms } = useWatch({ control: form.control });

  const nextButtonProps = {
    onClick: scrollToTop,
    disabled: isLoading || !acceptedTerms,
  };

  const onSubmit = (submittedData) => {
    if (handleContinue) {
      handleContinue({
        ...data,
        ...submittedData,
      });
    }
  };

  return {
    form,
    isLoading,
    nextButtonProps,
    onSubmit,
  };
}
